export const colors = {
  primary: "#F15BB5",
};

export const GOOGLE_MAP_KEY = "AIzaSyDSEh4qIEa7qVsEzV5A7qD8J6wDYpjo3Hk";
